import React from 'react'
import styled from 'styled-components'
import {
  BodyLargeRegular,
  Button,
  DisplaySmall,
  TextButton,
  Input,
} from 'prospect-path-base';
import CheckEmailBanner from '../../components/CheckEmailBanner';
import { connect } from 'react-redux';

import DefaultContainer from '../../components/register/Container'
import Header from '../../components/register/Header'
import resendSignUpEmail from '../../actions/ResendSignUpEmail';
import NotFound from '../not-found'

const Content = styled.div`
  max-width: 25rem;
  display: flex;
  margin: auto;
  flex-direction: column;
`

const Container = styled(DefaultContainer)`
  flex-direction: column;
`

const Title = styled(DisplaySmall)`
  margin-bottom: 1.5rem;
`

const Instructions = styled(BodyLargeRegular).attrs({
  as: 'p',
})`
  margin: 1.5rem 0;
`

class CheckEmail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      showEmailBanner: false,
    };

    this.getEmail = this.getEmail.bind(this);
    this.resend = this.resend.bind(this);
  }
  getEmail() {
    if (this.state.email === null) {
      return this.props.pendingUser.email;
    }

    return this.state.email;
  }
  resend() {
    this.props.resendSignUpEmail(this.getEmail())
      .then((success) => {
        if (success) {
          this.setState({
            email: null,
            showEmailBanner: true,
          });
        }
      });
  }
  render() {
    if (this.props.pendingUser.email === null) {
      return <NotFound />
    }


    return (
      <Container>
        <Header/>

        <Content>
          <Title>Check your inbox</Title>

          {this.state.showEmailBanner ? <CheckEmailBanner/> : ''}

          <svg width="400" height="208" viewBox="0 0 400 208" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <defs/>
            <rect width="400" height="208" rx="16" fill="#EBF5F6"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M121.794 77.767a7.2 7.2 0 017.2-7.2h142.8a7.2 7.2 0 017.2 7.2v81.6a7.2 7.2 0 01-7.2 7.2h-142.8a7.2 7.2 0 01-7.2-7.2v-81.6z"
                  fill="#04C5DC"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M121.794 77.767a7.2 7.2 0 017.2-7.2h142.8a7.2 7.2 0 017.2 7.2v81.6a7.2 7.2 0 01-7.2 7.2h-142.8a7.2 7.2 0 01-7.2-7.2v-81.6z"
                  fill="url(#paint0_radial)"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M125.15 71.974c-.996.654-.533 2.203.659 2.203h149.169c1.192 0 1.655-1.549.659-2.203l-71.293-46.793a7.199 7.199 0 00-7.901 0L125.15 71.974z"
                  fill="#04C5DC"/>
            <mask id="a" maskUnits="userSpaceOnUse" x="124" y="24" width="153" height="51">
              <path fillRule="evenodd" clipRule="evenodd"
                    d="M125.15 71.974c-.996.654-.533 2.203.659 2.203h149.169c1.192 0 1.655-1.549.659-2.203l-71.293-46.793a7.199 7.199 0 00-7.901 0L125.15 71.974z"
                    fill="#fff"/>
            </mask>
            <g mask="url(#a)" fillRule="evenodd" clipRule="evenodd" fill="#000" fillOpacity=".08">
              <path
                d="M139.794 61.767l4-3v26h-4v-23zM169.794 35.767h61v11h-61v-11zM255.794 58.767h4v26h-4v-26z"/>
            </g>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M128.507 74.973c-1.993-1.308-1.067-4.406 1.317-4.406h141.139c2.384 0 3.31 3.098 1.317 4.406l-67.936 44.591a7.2 7.2 0 01-7.901 0l-67.936-44.59z"
                  fill="#00808F"/>
            <path
              d="M143.894 47.567a6.7 6.7 0 016.7-6.7h99.6c3.701 0 6.7 2.99 6.7 6.69V84.501l-52.757 35.541a6.702 6.702 0 01-7.487 0l-52.756-35.541V47.567z"
              fill="#fff" stroke="#E2E2E2"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M127.572 162.256c-1.848 1.382-.871 4.321 1.437 4.321h142.769c2.308 0 3.286-2.939 1.437-4.321l-64.196-48.017a14.4 14.4 0 00-17.25 0l-64.197 48.017z"
                  fill="#04C5DC"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M184.794 166.767a4.858 4.858 0 013.179-6.476l19.021-5.419 3.6-16.8.265-.465c2.587-4.526 8.664-7.324 12.935-4.335.109.076 2.197 2.898 3.142 4.179.303.41.513.879.62 1.377l3.438 16.044 18.902 5.476a5.55 5.55 0 013.898 6.419h-69z"
                  fill="url(#paint1_linear)"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M121.794 84.767c2.375-1.902 5.92-.81 6.813 2.099l5.187 16.901 11.432 3.048c2.378.634 4.797 1.263 6.861 2.602 1.816 1.179 3.707 2.976 3.707 5.35 0 4.005-5.384 7.138-6.708 7.848a2.99 2.99 0 01-.61.241l-14.682 4.111-5.654 19.383c-.819 2.807-4.411 3.609-6.346 1.417v-63z"
                  fill="url(#paint2_linear)"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M216.209 136.993l-1.076 2.684-3.857 17.314-15.388 3.857-3.039 1.015c-2.732.913-2.732 4.778 0 5.691l3.039 1.015 15.388 3.857 3.857 17.314 1.015 3.038c.913 2.733 4.778 2.733 5.691 0l1.015-3.038 3.858-17.314 15.387-3.857 3.039-1.015c2.732-.913 2.732-4.778 0-5.691l-3.039-1.015-15.387-3.857-3.858-17.314-1.076-2.684c-1.007-2.511-4.562-2.511-5.569 0z"
                  fill="url(#paint3_linear)"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M121.409 86.593l-1.076 2.684-3.858 17.314-15.387 3.857-3.039 1.015c-2.732.913-2.732 4.778 0 5.691l3.039 1.015 15.387 3.857 3.858 17.314 1.015 3.038c.913 2.733 4.778 2.733 5.691 0l1.015-3.038 3.858-17.314 15.387-3.857 3.039-1.015c2.732-.913 2.732-4.778 0-5.691l-3.039-1.015-15.387-3.857-3.858-17.314-1.076-2.684c-1.007-2.511-4.562-2.511-5.569 0z"
                  fill="url(#paint4_linear)"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M257.294 57.367v4.8c3.584 1.195 18.1 2.4 18.1 2.4v45.6l-11.4-25.2s-7.8-3-13.8-4.8c-7.755-2.327-12-5.88-12-9.6 0-9.6 19.1-13.2 19.1-13.2z"
                  fill="url(#paint5_linear)"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M273.213 33.66l-1.87 4.613-4.628 20.55-18.252 4.624-5.352 1.808c-2.72.919-2.72 4.766 0 5.684l5.352 1.809 18.252 4.624 4.628 20.55 1.808 5.352c.919 2.72 4.766 2.72 5.685 0l1.808-5.352 4.628-20.55 18.252-4.624 5.352-1.809c2.72-.918 2.72-4.765 0-5.684l-5.352-1.808-18.252-4.625-4.628-20.55-1.87-4.612c-1.013-2.498-4.548-2.498-5.561 0z"
                  fill="url(#paint6_linear)"/>
            <defs>
              <linearGradient id="paint1_linear" x1="182.794" y1="129.672" x2="182.794" y2="166.767"
                              gradientUnits="userSpaceOnUse">
                <stop stopOpacity=".02"/>
                <stop offset="1" stopOpacity=".04"/>
              </linearGradient>
              <linearGradient id="paint2_linear" x1="155.794" y1="80.801" x2="121.794" y2="80.801"
                              gradientUnits="userSpaceOnUse">
                <stop stopOpacity=".02"/>
                <stop offset="1" stopOpacity=".04"/>
              </linearGradient>
              <linearGradient id="paint3_linear" x1="190.8" y1="135.11" x2="190.8" y2="194.827"
                              gradientUnits="userSpaceOnUse">
                <stop stopColor="#FCDB00"/>
                <stop offset="1" stopColor="#F8B400"/>
              </linearGradient>
              <linearGradient id="paint4_linear" x1="96" y1="84.71" x2="96" y2="144.427"
                              gradientUnits="userSpaceOnUse">
                <stop stopColor="#FCDB00"/>
                <stop offset="1" stopColor="#F8B400"/>
              </linearGradient>
              <linearGradient id="paint5_linear" x1="238.194" y1="57.367" x2="238.194" y2="110.167"
                              gradientUnits="userSpaceOnUse">
                <stop stopOpacity=".02"/>
                <stop offset="1" stopOpacity=".04"/>
              </linearGradient>
              <linearGradient id="paint6_linear" x1="241.071" y1="31.787" x2="241.071" y2="105.314"
                              gradientUnits="userSpaceOnUse">
                <stop stopColor="#FCDB00"/>
                <stop offset="1" stopColor="#F8B400"/>
              </linearGradient>
              <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                              gradientTransform="matrix(0 -96 157.2 0 200.394 166.567)">
                <stop stopOpacity=".24"/>
                <stop offset="1" stopColor="#fff" stopOpacity=".01"/>
              </radialGradient>
            </defs>
          </svg>

          { this.state.email === null && (
            <Instructions>
              Confirm your email address by clicking the link we sent to
              {` ${this.getEmail()}`} <TextButton
                style={{ display: 'inline-block' }}
                onClick={() => this.setState({ email: this.props.pendingUser.email })}
              >edit</TextButton>
            </Instructions>
          )}

          { this.state.email !== null && (
            <Instructions>
              Confirm your email address by clicking the link we sent to
              <Input
                value={this.state.email}
                onChange={event => this.setState({email: event.target.value})}
                name="email"
                type="email"
              />
            </Instructions>
          )}

          <Button size="small" color="secondary" onClick={this.resend}>
            Resend email
          </Button>
        </Content>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  pendingUser: state.pendingUser,
});
const mapDispatchToProps = dispatch => ({
  resendSignUpEmail: email => dispatch(resendSignUpEmail(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckEmail)
